import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching user's match sessions
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useMatchesQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["matches", userId],
    queryFn: async () => {
      const res = await api.get("/analytics/my-matches");
      return res.data.matchSessions || res.data.sessions || [];
    },
    enabled: enabled && !!userId,
  });
};

/**
 * Mutation hook for removing one saved match, or several at once.
 * A single id uses the existing route. An array uses the bulk route.
 */
export const useDeleteMatchMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (matchIdOrIds) => {
      if (Array.isArray(matchIdOrIds)) {
        const res = await api.delete("/analytics/my-matches", {
          data: { ids: matchIdOrIds },
        });
        return res.data;
      }
      const res = await api.delete(`/analytics/my-matches/${matchIdOrIds}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["matches"] });
    },
  });
};
